import gql from "graphql-tag";

export const VERIFY_POST_MUTATION = gql`
  mutation verifyPost($postId: String!, $verify: Boolean!) {
    verifyPost(postId: $postId, verify: $verify)
  }
`;
